<template>
    <div
        v-cloak
        class="row"
    >
        <div class="col-xs-12">
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">Users table</h3>
                    <div class="box-tools pull-right">
                        <button
                            type="button"
                            class="btn btn-box-tool"
                            data-widget="collapse"
                            data-toggle="tooltip"
                            title="Collapse"
                        >
                            <i class="fa fa-minus"></i>
                        </button>
                    </div>
                </div>
                <UserListTable
                    v-bind="$attrs"
                    :withCompany="true"
                ></UserListTable>
            </div>
        </div>
    </div>
</template>

<script>
import UserListTable from './templates/UsersListTable';

export default {
    components: {
        UserListTable,
    },
};
</script>
